export const VK_LEFT = 37
export const VK_UP = 38
export const VK_RIGHT = 39
export const VK_DOWN = 40